const currency = [
  { label: "IDR", value: "IDR" },
  { label: "USD", value: "USD" },
];

export default currency;
